import manifest from "@agentry/zerovia-contracts/manifest.json" with { type: "json" };
import { type HttpClientOptions, HttpZeroviaClient } from "./http/client.js";
import { type MockClientOptions, MockZeroviaClient } from "./mock/client.js";
import type { ApiMode, ZeroviaClient } from "./types.js";

export * from "./agentry-types.js";
export { ENDPOINTS } from "./endpoints.js";
export * from "./errors.js";
export { HttpZeroviaClient } from "./http/client.js";
export { MockZeroviaClient } from "./mock/client.js";
export * as mockSeed from "./mock/seed.js";
export {
	checksumOf,
	initialState,
	LocalStoragePersistence,
	MemoryPersistence,
	type MockState,
	type StatePersistence,
} from "./mock/store.js";
export * from "./types.js";

/** Pinした Zerovia Contract。Real接続時にこの値と一致しなければ接続しない。 */
export const CONTRACT_PIN = {
	contractVersion: manifest.contractVersion,
	contractHash: manifest.contractHash,
	schemaVersion: manifest.schemaVersion,
	modules: manifest.modules,
} as const;

export type CreateClientConfig = {
	mode: ApiMode;
	apiUrl?: string;
	authUrl?: string;
	mock?: MockClientOptions;
	http?: Partial<HttpClientOptions>;
};

/**
 * Mock / Real を1箇所で切り替える。画面はどちらが選ばれたかを知らない。
 * Real modeでURLが無い場合はMockへ黙って落とさず、設定不足として明示的に失敗させる。
 */
export function createZeroviaClient(config: CreateClientConfig): ZeroviaClient {
	if (config.mode === "mock") return new MockZeroviaClient(config.mock);

	const apiUrl = config.http?.apiUrl ?? config.apiUrl;
	const authUrl = config.http?.authUrl ?? config.authUrl;
	if (!apiUrl || !authUrl) {
		throw new Error(
			"Real modeにはVITE_ZEROVIA_API_URLとVITE_ZEROVIA_AUTH_URLが必要です。未設定のままMockへFallbackしません。",
		);
	}
	return new HttpZeroviaClient({
		...config.http,
		apiUrl,
		authUrl,
		localFallback: config.http?.localFallback ?? new MockZeroviaClient({ latencyMs: 0 }),
	});
}
